import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReturnReasonModal from '../../../../views/order/common/modal/ReturnReasonModal';
import { orderActions } from '../../../../store/modules/order';
import withModal from '../../../../lib/hoc/withModal';

class ReturnReasonModalContainer extends Component {
  /**
   * 모달 닫기
   */
  closeModal = () => {
    const { toggleModal } = this.props;
    toggleModal({
      name: 'returnReasonModal',
    });
  };

  render() {
    const { isOpen, data } = this.props;

    return <ReturnReasonModal isOpen={isOpen} data={data} closeModal={this.closeModal} />;
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.order.returnReasonModal.isOpen,
    data: state.order.returnReasonModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: orderActions.toggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(ReturnReasonModalContainer));
